// services/contact/api.ts

import axiosClient from '@/http/axiosClient'
import { CreateContactPayload, CreateContactResponse } from './type'

// Sử dụng chung Base URL và Site Key theo mẫu cũ (nếu khác bạn có thể đổi env variable)
const NEWS_BASE_URL = process.env.NEXT_PUBLIC_NEWS_BASE_URL as string
const SITE_KEY = process.env.NEXT_PUBLIC_NEWS_SITE_KEY as string

export const apiCreateContact = (payload: CreateContactPayload) =>
    axiosClient
        .post<CreateContactResponse>(
            '/contacts',
            payload,
            {
                baseURL: NEWS_BASE_URL,
                withCredentials: false,
                headers: {
                    siteKey: SITE_KEY,
                },
            }
        )
        .then((res) => res.data)